module.exports = __webpack_public_path__ + "img/222A5911.1b5c4105.png";